import { DispatchAssignmentBus } from "./DispatchAssignmentBus";
import { AssignablePersonBus } from "./AssignablePersonBus";

export class DispatchAssignmentGridBus extends DispatchAssignmentBus
{
    constructor(busObj: DispatchAssignmentBus = null) {
        super(busObj);
    }
    person: AssignablePersonBus;
    assignedFrom: string = ""; //T-Techs, V-Visited, N-Near
    //fullName: string;
    //contactEmail: string;
    //mainNumber: string;
    //cellNumber: string;
}
